export default __webpack_public_path__ + "static/media/Vector3.14369b5a.svg";